import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Bold = ({ ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    <>
      <path
        d='M5 4.89449C5 3.85239 5.88421 2.99976 6.96491 2.99976H11.9951C14.5691 2.99976 16.6618 5.01765 16.6618 7.49976C16.6618 9.98186 14.5691 11.9998 11.9951 11.9998H5V4.89449Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5 12.0002H14.3333C16.9074 12.0002 19 14.0181 19 16.5002C19 18.9823 16.9074 21.0002 14.3333 21.0002H6.96491C5.88421 21.0002 5 20.1476 5 19.1055V12.0002V12.0002Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  </IconBase>
);
